import React from 'react';

interface CircleArrowProps {
  className?: string;
}

export const CircleArrow: React.FC<CircleArrowProps> = ({ className }) => {
  return (
    <svg
      className={className}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="24" fill="#FCE7F7" />
      <path
        d="M23 31.5V19.914L18.5 24.414L17.086 23L24 16.086L30.914 23L29.5 24.414L25 19.914V31.5H23Z"
        fill="#E50AAC"
      />
    </svg>
  );
};
